export const SET_SENSORS_QUERY = 'SET_SENSORS_QUERY'
export const SET_GRAPH_DATA_SETTINGS = 'SET_GRAPH_DATA_SETTINGS'
export const TOGGLE_YEAR_VIZ = 'TOGGLE_YEAR_VIZ'
export const TOGGLE_MIN_MAX = 'TOGGLE_MIN_MAX'
export const TOGGLE_GROUP_BY = 'TOGGLE_GROUP_BY'
export const TOGGLE_DATA_POINTS = 'TOGGLE_DATA_POINTS'
